module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNDUwIj48cGF0aCBkPSJNMCA0NTBoOTAwVjBIMHoiIGZpbGw9IiNkNjI4MjgiLz48cGF0aCBkPSJNMCA0NTBWMGg2MDB6IiBmaWxsPSIjZmNkODU2Ii8+PHBhdGggZD0iTTAgNDUwVjBoMzAweiIgZmlsbD0iIzAwM2Y4NyIvPjxwYXRoIGQ9Ik0wIDQ1MGg5MDBWMTUweiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0wIDQ1MGg5MDBWMzAweiIgZmlsbD0iIzAwN2EzZCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/syc.svg
// module id = airY
// module chunks = 0